// Native taps carry a real instant. Manual editors keep schedule-local wall time.
export function confirmationTimeFields(confirmedAt) {
    if (!confirmedAt) return {};
    return /(?:Z|[+-]\d{2}:\d{2})$/i.test(confirmedAt) ? { confirmedAtInstant: confirmedAt } : { confirmedAt };
}
